export default "__VITE_ASSET__aba2a6f1__"